import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DescricaoPadraoListarComponent } from './descricao-padrao-listar/descricao-padrao-listar.component';
import { DescricaoPadraoAdicionarComponent } from './descricao-padrao-adicionar/descricao-padrao-adicionar.component';
import { DescricaoPadraoEditarComponent } from './descricao-padrao-editar/descricao-padrao-editar.component';

const routes: Routes = [
  { path: '', component: DescricaoPadraoListarComponent },
  { path: 'adicionar', component: DescricaoPadraoAdicionarComponent },
  { path: 'editar/:id', component: DescricaoPadraoEditarComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DescricaoPadraoRoutingModule { }
